import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./en.json";
import de from "./de.json";
import es from "./es.json";
import tr from "./tr.json";
import hi from "./hi.json";
import ar from "./ar.json";
import it from "./it.json";
import ru from "./ru.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
    es: { translation: es },
    tr: { translation: tr },
    hi: { translation: hi },
    ar: { translation: ar },
    it: { translation: it },
    ru: { translation: ru },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
